import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import MainLayout from "./layout";

// Lazy Router - Dynamic imports for route code splitting
const Home = lazy(() => import("./home"));
const BriefHistory = lazy(() => import("./pages/AboutUs/BriefHistory"));
const BishopProfile = lazy(() => import("./pages/AboutUs/BishopProfile"));
const PopeMessage = lazy(() => import("./pages/AboutUs/PopeMessage"));
const PastoralMessage = lazy(() => import("./pages/AboutUs/PastoralMessage"));
const BishopProgram = lazy(() => import("./pages/AboutUs/BishopProgram"));
const Commission = lazy(() => import("./pages/TheDiocese/Commission"));
const ReligiousData = lazy(() => import("./pages/ReligiousCongregation/ReligiousData"));
const ReligiousPriest = lazy(() => import("./pages/ReligiousCongregation/Details/ReligiousPriest"));
const ReligiousSisters = lazy(() => import("./pages/ReligiousCongregation/ReligiousSisters"));
const Institutions = lazy(() => import("./pages/Institutions/Institutions"));
const AllLatestNews = lazy(() => import("./pages/LatestNews/AllLatestNews"));
const AllFlashNews = lazy(() => import("./pages/LatestNews/AllFlashNews"));
const Gallery = lazy(() => import("./pages/Multimedia/Gallery"));
const Videos = lazy(() => import("./pages/Multimedia/Videos"));
const Articles = lazy(() => import("./pages/Multimedia/Articles"));
const Newsletter = lazy(() => import("./pages/Multimedia/Newsletter"));
const Activities = lazy(() => import("./pages/Activity/Activities"));
const AllActivity = lazy(() => import("./pages/Activity/AllActivity"));
const Contact = lazy(() => import("./pages/Contact/Contact"));
const Calendar = lazy(() => import("./pages/Calendar/Calendar"));
const News = lazy(() => import("./pages/News/News"));
const NotFound = lazy(() => import("./NotFound"));
const AllNews = lazy(() => import("./pages/News/AllNews"));
const AllCommissions = lazy(() => import("./pages/Commissions/AllCommissions"));
const EducationCommission = lazy(() => import("./pages/TheDiocese/EducationCommission"));
const PastoralCommission = lazy(() => import("./pages/TheDiocese/PastoralCommission"));
const SocialServiceCommission = lazy(() => import("./pages/TheDiocese/SocialServiceCommission"));
const YouthCommission = lazy(() => import("./pages/TheDiocese/YouthCommission"));
const Priests = lazy(() => import("./pages/AboutUs/Priests"));
const Seminarians = lazy(() => import("./pages/TheDiocese/Seminarians"));
const CollegeConsultors = lazy(() => import("./pages/Diocesan Curia/CollegeOfConsultors"));
const Vicars = lazy(() => import("./pages/Diocesan Curia/Vicars"));
const PresbyteralCouncil = lazy(() => import("./pages/Diocesan Curia/PresbyteralCouncil"));
const FinanceCouncil = lazy(() => import("./pages/Diocesan Curia/FinanceCouncil"));
const Parishes = lazy(() => import("./pages/TheDiocese/Parishes"));
const DetailParish = lazy(() => import("./pages/TheDiocese/DetailParish"));
const BriefPriestDetails = lazy(() => import("./pages/AboutUs/BriefPriestDetails"));
const RetiredPriestDetails = lazy(() => import("./pages/AboutUs/RetiredPriestDetails"));
const Donation = lazy(() => import("./pages/Donation/Donation"));

import { SiteDataProvider } from "./context/SiteDataContext";

const PageLoader = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "50vh",
    }}
  >
    <PulseLoader
      color="#0d4571"
      size={8}
      aria-label="Loading..."
      data-testid="loader"
    />
  </div>
);

function App() {
  return (
    <SiteDataProvider>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/*" element={<MainLayout />}>
            {/* About Us Page Routing */}
            <Route path="history" element={<BriefHistory />} />
            <Route path="bishop-profile" element={<BishopProfile />} />
            <Route path="pope-message" element={<PopeMessage />} />
            <Route path="pastoral-message" element={<PastoralMessage />} />
            <Route path="bishop-program" element={<BishopProgram />} />
            <Route path="diocesan-curia" element={<CollegeConsultors />} />
            <Route path="vicars" element={<Vicars />} />
            <Route path="presbyteral-council" element={<PresbyteralCouncil />} />
            <Route path="College-of-Consultors" element={<CollegeConsultors />} />
            <Route path="college-of-consultors" element={<CollegeConsultors />} />
            <Route path="college-consultors" element={<CollegeConsultors />} />
            <Route path="Financial-council" element={<FinanceCouncil />} />
            <Route path="financial-council" element={<FinanceCouncil />} />
            <Route path="Finance-council" element={<FinanceCouncil />} />
            <Route path="finance-council" element={<FinanceCouncil />} />
            <Route path="aboutus" element={<BriefHistory />} />
            <Route path="college-consult" element={<CollegeConsultors />} />
            <Route path="senate-members" element={<CollegeConsultors />} />
            <Route path="marriage-tribunal" element={<CollegeConsultors />} />
            <Route path="birthday-calendar" element={<BriefHistory />} />
            <Route path="ordination-calendar" element={<BriefHistory />} />
            <Route path="necrology" element={<BriefHistory />} />
            <Route path="priests" element={<Priests />} />
            {/* The Diocese Page Routing */}
            <Route path="parishes" element={<Parishes />} />
            <Route path="parish-more-details" element={<DetailParish />} />
            <Route path="pastoral-commission" element={<PastoralCommission />} />
            <Route path="education-commission" element={<EducationCommission />} />
            <Route path="social-service-commission" element={<SocialServiceCommission />} />
            <Route path="youth-commission" element={<YouthCommission />} />
            <Route path="deaneries" element={<Commission />} />
            <Route path="cathedral" element={<Commission />} />
            <Route path="diocesan-shrine" element={<Commission />} />
            <Route path="joharapuram" element={<Commission />} />
            <Route path="guntakal" element={<Commission />} />
            <Route path="maddikera" element={<Commission />} />
            <Route path="nandikotkur" element={<Commission />} />
            <Route path="chapirevula" element={<Commission />} />
            <Route path="premagiri" element={<Commission />} />
            <Route path="srisailam" element={<Commission />} />
            <Route path="yathrikulamatha" element={<Commission />} />
            <Route path="krishnapuram" element={<Commission />} />
            <Route path="seminarians" element={<Seminarians />} />
            {/* Religious Congregation Page Routing */}
            <Route path="religious-priest" element={<ReligiousData />} />
            <Route path="detail-priest" element={<ReligiousPriest />} />
            <Route path="religious-sisters" element={<ReligiousSisters />} />
            {/* Institutions Page Routing */}
            <Route path="destitute-home" element={<Institutions />} />
            <Route path="old-age-home" element={<Institutions />} />
            <Route path="hospital-dispen" element={<Institutions />} />
            <Route path="leprosy-centre" element={<Institutions />} />
            <Route path="mental-retired-home" element={<Institutions />} />
            <Route path="handicapped-home" element={<Institutions />} />
            <Route path="ecclesiastical" element={<Institutions />} />
            <Route path="boarding-homes" element={<Institutions />} />
            <Route path="colleges" element={<Institutions />} />
            <Route path="elementary-schools" element={<Institutions />} />
            <Route path="high-schools" element={<Institutions />} />
            <Route path="technical-training-school" element={<Institutions />} />
            {/* All Latest News Page Routing */}
            <Route path="all-latest-news" element={<AllLatestNews />} />
            <Route path="all-flash-news" element={<AllFlashNews />} />
            {/* Multimedia Page Routing */}
            <Route path="gallery" element={<Gallery />} />
            <Route path="video-song" element={<Videos />} />
            <Route path="articles" element={<Articles />} />
            <Route path="newsletter" element={<Newsletter />} />
            {/* Activity Page Routing */}
            <Route path="activity" element={<Activities />} />
            <Route path="all-activity" element={<AllActivity />} />
            {/* Contact Us Page Routing */}
            <Route path="contactus" element={<Contact />} />
            {/* Calendar Page Routing  */}
            <Route path="calendar" element={<Calendar />} />
            {/* News Page Routing */}
            <Route path="news" element={<News />} />
            <Route path="allnews" element={<AllNews />} />
            <Route path="all-commission" element={<AllCommissions />} />
            {/* All Priest Details Page Routing */}
            <Route path="priest-brief-details" element={<BriefPriestDetails />} />
            <Route path="retired-priest-brief-details" element={<RetiredPriestDetails />} />
            <Route path="donation" element={<Donation />} />
            {/* Default Page Routing */}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>
    </SiteDataProvider>
  );
}

export default App;

